import {
  AffiliationConfig,
  AffiliationConfigToUpdate,
  AffiliationMarketFilters,
  AffiliationMarketProduct,
} from '@interfaces/affiliationConfig';
import { Product } from '@interfaces/product';
import { fetcher } from '@utils/fetcher';
import { objectIntoQueryString } from '@utils/parseObjectValues';

const getApiUrl = (productId: Product['id']) =>
  `/api/products/${productId}/affiliationConfig`;

export const findAffiliationConfig = async (
  productId: Product['id'],
): Promise<AffiliationConfig> =>
  fetcher(getApiUrl(productId), { method: 'GET' });

export const updateAffiliationConfig = async (
  productId: Product['id'],
  dto: Partial<AffiliationConfigToUpdate>,
): Promise<AffiliationConfig> =>
  fetcher(getApiUrl(productId), {
    method: 'PATCH',
    body: dto,
  });

export const findMarketProducts = async (
  filters?: AffiliationMarketFilters,
): Promise<AffiliationMarketProduct[]> => {
  const queryString = filters ? objectIntoQueryString(filters) : '';
  return fetcher('/api/affiliationConfig' + queryString);
};

export const findMarketProduct = async (
  param: AffiliationMarketProduct['productCode'],
): Promise<AffiliationMarketProduct> => {
  return fetcher(`/api/affiliationConfig/${param}`);
};
